import { NgModule } from '@angular/core';
import { FocusOnShowDirective } from './autofocus.directive';

@NgModule({
    declarations: [FocusOnShowDirective],
    exports: [FocusOnShowDirective],
})
export class AutofocusModule {}
